// @flow
import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import licenseActionKeys from './licenseActionKeys';

export default (combineReducers({
  getAtlasOrgStates: AsyncRequest.createReducer(licenseActionKeys.GET_ORG_STATES),
  getAtlasOrgsByState: AsyncRequest.createReducer(licenseActionKeys.GET_ORGS_BY_STATE),
  getAtlasOrgFields: AsyncRequest.createReducer(licenseActionKeys.GET_ORG_FIELDS),
}): any);



// WEBPACK FOOTER //
// ./src/modules/profile/common/licenseReducer.js